// extracted by mini-css-extract-plugin
export default {"reset":"l1OYIw","visuallyHidden":"i01AEJ"};